export const normalizeHexColor = (value?: string | null): string | null => {
  if (!value) {
    return null
  }

  const normalized = value.trim().replace(/^#/, '')

  if (/^[0-9a-f]{3}$/i.test(normalized)) {
    const expanded = normalized
      .split('')
      .map((char) => `${char}${char}`)
      .join('')

    return `#${expanded.toUpperCase()}`
  }

  if (/^[0-9a-f]{6}$/i.test(normalized)) {
    return `#${normalized.toUpperCase()}`
  }

  return null
}
